import useIsContentForceCentered from '@hooks/useIsContentForceCentered'
import {
  desktopCenteredContentCSS,
  desktopLeftAlignedCSS,
  mobileCSS,
  tabletCSS,
} from '@measures/responsive'
import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface SidebarAdWrapperProps {
  isErrorPage: boolean
  children?: ReactNode
}

type StyledSidebarAdWrapperProps = Pick<
  SidebarAdWrapperProps,
  'isErrorPage'
> & {
  isContentForceCentered: boolean
}

const StyledSidebarAdWrapper = styled.div<StyledSidebarAdWrapperProps>`
  ${({ isErrorPage, isContentForceCentered }) => css`
    display: grid;
    position: relative;
    grid-auto-flow: column;
    z-index: 4;
    grid-column: 2;

    ${desktopCenteredContentCSS(css`
      ${isErrorPage
        ? css`
            grid-auto-flow: column;
          `
        : css`
            grid-column: 3;
            grid-template-columns: minmax(0, 1fr) 994px minmax(0, 1fr);
          `}
    `)}

    ${desktopLeftAlignedCSS(css`
      ${isErrorPage
        ? css`
            grid-auto-flow: column;
          `
        : isContentForceCentered
        ? css`
            grid-column: 3;
            grid-template-columns: minmax(0, 1fr) 994px minmax(0, 1fr);
          `
        : css`
            grid-template-columns: 994px minmax(0, 1fr);
          `}
    `)}

    ${tabletCSS(
      isErrorPage
        ? css`
            grid-auto-flow: column;
          `
        : css`
            grid-template-columns: 768px;
            justify-content: center;
          `
    )}

    ${mobileCSS(css`
      grid-template-columns: minmax(0, 1fr);
    `)}
  `}
`

const SidebarAdWrapper: FunctionComponent<SidebarAdWrapperProps> = ({
  children,
  isErrorPage,
}) => {
  const isContentForceCentered = useIsContentForceCentered()
  return (
    <StyledSidebarAdWrapper
      isErrorPage={isErrorPage}
      isContentForceCentered={isContentForceCentered}>
      {children}
    </StyledSidebarAdWrapper>
  )
}

export default SidebarAdWrapper
